<script setup lang="ts">

import { onMounted, reactive, watch } from "vue";
import logo from "@/assets/images/favicon.png";

import { usuarioLogado } from "@/utils/funcoes";

import * as service from "@/services/paramsService";

var props = defineProps({
  Externo: { type: Boolean, required: true, default: false },
  Titulo: { type: String, required: false, default: "Não informado!" },
  Filtros: { type: String, required: false, default: "" },
});

var controle = reactive({
  externo: props.Externo,
  filtros: props.Filtros,
  titulo: props.Titulo,
  parametros: {} as service.Param,
  erro: "",
});

watch(() => props.Externo, async (novo) => {
  controle.externo = novo;
})

watch(() => props.Titulo, async (novo) => {
  controle.titulo = novo;
})

watch(() => props.Filtros, async (novo) => {
  controle.filtros = novo;
})

const obterParametros = () => {
  service.obter()
    .then((r) => {
      controle.parametros = r[0];
    })
    .catch((erro) => {
      setTimeout(() => {
        controle.erro = erro;
        obterParametros();
      }, 1000);
    });
};

onMounted(() => {
  obterParametros();
});

watch(
  () => props,
  (novo: any) => {
    controle.titulo = novo.Titulo;
    controle.filtros = novo.Filtros;
    obterParametros();
  },
  { deep: true },
);
</script>
<template>


  <div class="rel-interno d-flex flex-row align-items-center w-100">
    <div class="flex-column" style="width: 15%">
      <img class="imagem" :src="logo" />
    </div>

    <div class="flex-column" style="width: 70%" v-if="controle.externo">
      <div class="titulo mb-1">{{ controle.parametros.relatorioLinha1 }}</div>
      <div class="titulo2 mb-1">{{ controle.parametros.relatorioLinha2 }}</div>
      <div class="titulo3 mb-1">{{ controle.parametros.relatorioLinha3 }}</div>
      <div class="titulo4 mb-1">{{ controle.titulo }}</div>
    </div>

    <div class="flex-column" style="width: 70%" v-else>
      <div class="titulo mb-1">{{ controle.parametros.relatorioLinha1 }}</div>
      <div class="subtitulo">{{ controle.titulo }}</div>
      <div class="filtros">{{ controle.filtros }}</div>
    </div>

    <div class="flex-column" style="width: 15%">
      <div class="usuario">{{ usuarioLogado()?.usuarioId }} - {{ usuarioLogado()?.nomeUsuario }}</div>

      <div class="data">{{ new Date().toLocaleString() }}</div>
    </div>
  </div>


</template>
<style>
table {
  width: 100%;
}

.imagem {
  height: 50px !important;
}

.col1,
.col2 {
  min-width: 15%;
  max-width: 15%;
  width: 15%
}

.titulo {
  font-size: 16px;
  font-weight: 700;
  text-align: center;
  line-height: 10px;
}

.titulo2,
.titulo3 {
  text-align: center;
  line-height: 10px;
}

.titulo4 {
  text-align: center;
  line-height: 10px;
  font-weight: 700;
}


.subtitulo {
  font-size: 14px;
  font-weight: 700;
  text-align: center;
  line-height: 10px;
}

.usuario,
.data {
  text-align: right;
  font-size: 8px;
}

.filtros {
  font-size: 10px;
  text-align: center;
  line-height: 12px;
}
</style>
